import type { InvoiceTemplate } from '~/api/invoiceTemplates/types';

import { useUser } from '~/api/user';
import { BrandDot } from '~/components';
import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { titleStyle } from './invoiceTemplateCell.css';

type Props = {
  invoiceTemplate: InvoiceTemplate;
};

export const InvoiceTemplateTitleCell = ({ invoiceTemplate }: Props) => {
  const { data: user } = useUser();

  const brand = user.brands.find(({ id }) => id === invoiceTemplate.brandId);

  return (
    <div className={clsx(titleStyle, desktopTruncateStyle)}>
      {brand && brand.color && <BrandDot color={brand.color} small />}

      <span className={desktopTruncateStyle}>{invoiceTemplate.title}</span>
    </div>
  );
};
